import { getMessengerChannelLabel } from "./messengers";

/** Короткая инструкция для HR: как раздать ссылку сотрудникам. */
export function getHrShareInstruction(messengerIds = ["telegram", "max"]) {
  const ids = Array.isArray(messengerIds) ? messengerIds.filter(Boolean) : ["telegram"];
  const channels = ids.map((id) => getMessengerChannelLabel(id)).join(" или ");

  return (
    `Скопируйте ссылку ниже и отправьте её сотрудникам в корпоративный чат, по email или в LMS — ` +
    `каждый открывает её в ${channels}, нажимает «Запустить бота» и проходит программу. ` +
    `Краткая инструкция для сотрудников: club-lab.ru/dlya-sotrudnika. ` +
    `Один сотрудник = одно место по тарифу; новые люди смогут войти, пока не исчерпан лимит команды.`
  );
}
